import { useState } from 'react';

const useForm = (onSuccess) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [fieldErrors, setFieldErrors] = useState([]);

    const handleSubmit = async (onSubmit, formData) => {
        setLoading(true);
        try {
            await onSubmit(formData);
            setLoading(false);
            setError('');
            setFieldErrors([]);
            onSuccess();
        } catch (err) {
            setError(err.message);
            if (err.data && Array.isArray(err.data)) {
                setFieldErrors(err.data);
            }
            setLoading(false);
        }
    };

    return {
        loading,
        error,
        fieldErrors,
        handleSubmit
    };
};

export default useForm;
